import React from "react";
import { Helmet } from "react-helmet-async";
import "./FounderPage.css";
import ceoImg from "../assets/ceo.webp";

function FounderPage() {
  return (
    <div className="founder-page">

      {/* SEO */}
      <Helmet>
        <title>Vaibhav Anpat | Founder & CEO of WEMS Modular OT India</title>

        <meta
          name="description"
          content="Vaibhav Anpat is the Founder & CEO of Wellness Electromedical Systems Pvt Ltd (WEMS), specializing in Modular Operation Theatre, Laminar Air Flow systems, and hospital infrastructure in India."
        />

        <meta
          name="keywords"
          content="Vaibhav Anpat, WEMS founder, Modular OT India, Operation Theatre systems, Laminar airflow OT, hospital infrastructure Pune"
        />

        <link
          rel="canonical"
          href="https://www.wellnessmodularot.com/vaibhav-anpat"
        />

        {/* Open Graph */}
        <meta property="og:title" content="Vaibhav Anpat | Founder of WEMS" />
        <meta
          property="og:description"
          content="Founder & CEO of WEMS specializing in Modular OT and hospital air systems in India."
        />
        <meta
          property="og:image"
          content="https://www.wellnessmodularot.com/assets/ceo.jpg"
        />
        <meta
          property="og:url"
          content="https://www.wellnessmodularot.com/vaibhav-anpat"
        />
        <meta property="og:type" content="profile" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Vaibhav Anpat | Founder of WEMS"
        />
        <meta
          name="twitter:description"
          content="Founder of WEMS Modular OT India"
        />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",
            name: "Vaibhav Anpat",
            jobTitle: "Founder & CEO",
            worksFor: {
              "@type": "Organization",
              name: "Wellness Electromedical Systems Pvt. Ltd.",
            },
            url: "https://www.wellnessmodularot.com/vaibhav-anpat",
            image: "https://www.wellnessmodularot.com/assets/ceo.jpg",
            description:
              "Founder & CEO of WEMS specializing in Modular Operation Theatre systems and hospital air technology in India.",
          })}
        </script>
      </Helmet>

      {/* Hero Section */}
      <div className="founder-hero">
        <img src={ceoImg} alt="Vaibhav Anpat Founder WEMS" />

        <div className="hero-text">
          <h1>Vaibhav Anpat</h1>
          <p className="role">Founder & CEO</p>
          <p className="company">
            Wellness Electromedical Systems Pvt. Ltd.
          </p>
        </div>
      </div>

      {/* Story Section */}
      <div className="founder-content">

        <h2>Founder Story</h2>

        <p>
          My journey into healthcare infrastructure didn’t begin in a boardroom—it began at home.
        </p>

        <p>
          When my grandmother battled a hospital-acquired infection, I witnessed firsthand how critical air quality is in patient recovery. That experience stayed with me. It made me question something most people never think about—<span>*the air inside hospitals.*</span>
        </p>

        <p>
          On <strong>17th November 2015</strong>, I stepped into the field of healthcare air technology with a clear purpose: to contribute to safer, cleaner environments for patients and healthcare professionals.
        </p>

        <p>
          Over the years, I specialized in advanced air systems such as <strong>Laminar Air Flow (LAF) Operation Theatres</strong> and controlled cleanroom environments. These systems are designed to minimize contamination risks and maintain sterile conditions—an essential factor in modern surgeries and critical care.
        </p>

        <p>
          This journey led to the foundation of <strong>Wellness Electromedical Systems Pvt. Ltd.</strong>, where our focus is simple yet vital: delivering reliable, efficient, and high-performance air technology solutions that support infection control and patient safety.
        </p>

        <p className="highlight">
          We don’t just install systems—we create environments where healing is protected.
        </p>

        <p>
          Today, our mission continues to evolve with technology, but the purpose remains the same:
        </p>

        <p className="mission">
          To ensure that no patient suffers due to compromised air quality in healthcare spaces.
        </p>

        <div className="signature">
          — Vaibhav Anpat <br />
          Founder & CEO, WEMS
        </div>
      </div>
    </div>
  );
}

export default FounderPage;